<button mat-icon-button class="close-button" mat-dialog-close>
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
<h2 mat-dialog-title class="dialog-title">Delete Branch</h2>

<mat-dialog-content class="mat-typography">
  
    <div class="confirm-delete text-center">
        <mat-icon>delete</mat-icon>
        <p class="fs-6 mt-3">Are you sure you want to delete “Branch”?</p>
        <p class=""><small>This will delete the branch permanently</small></p>
    </div>
    
</mat-dialog-content>
<mat-dialog-actions  [align]="'end'" class="dialog-actions">
  <button mat-button mat-dialog-close class="cancel-btn">{{'Language.CancelText' | translate}}</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial class="bg-danger">{{'Language.DeleteText' | translate}}</button>
</mat-dialog-actions>